import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASection = () => {
  const benefits = [
    { icon: "Clock", text: "Setup in 24 hours" },
    { icon: "Bell", text: "Real-time alerts" },
    { icon: "Users", text: "Dedicated support" },
    { icon: "TrendingUp", text: "100K+ policies tracked" }
  ];

  return (
    <section className="bg-gradient-to-br from-[#1B1B20] via-[#1B1B20] to-[#0A0A0A] py-16 md:py-20 lg:py-28 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 md:w-[32rem] md:h-[32rem] bg-[#1A73E8] rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 md:w-[32rem] md:h-[32rem] bg-[#ED1C24] rounded-full blur-3xl"></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 md:px-4 md:py-2 bg-[#ED1C24]/20 rounded-full mb-6 md:mb-8 border border-[#ED1C24]/30">
            <Icon name="Zap" size={16} color="#ED1C24" />
            <span className="text-xs md:text-sm font-medium text-[#ED1C24]">Start Monitoring Today</span>
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6">
            Never Miss Another<br />Policy Change
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-gray-300 mb-8 md:mb-10 leading-relaxed">
            Join healthcare organizations who trust PolicyAlerts to monitor critical medical policy changes across all payers. Request your demo today.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center mb-10 md:mb-12">
            <Button 
              variant="default" 
              size="lg"
              iconName="Calendar"
              iconPosition="left"
              className="bg-[#ED1C24] hover:bg-[#ED1C24]/90 text-white"
              asChild
            >
              <Link to="/request-demo">Request Demo</Link>
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              iconName="Play"
              iconPosition="left"
              className="border-white/30 text-white hover:bg-white/10"
              asChild
            >
              <Link to="/platform-demo">Watch Platform Demo</Link>
            </Button>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 lg:gap-8">
            {benefits?.map((benefit, idx) => (
              <div 
                key={idx}
                className="flex flex-col items-center gap-2 md:gap-3 p-4 md:p-6 bg-white/5 rounded-xl backdrop-blur-sm border border-white/10 hover:bg-white/10 transition-colors"
              >
                <div className="w-10 h-10 md:w-12 md:h-12 bg-[#1A73E8]/20 rounded-full flex items-center justify-center">
                  <Icon name={benefit?.icon} size={20} color="#1A73E8" />
                </div>
                <p className="text-xs md:text-sm text-white font-medium text-center">{benefit?.text}</p>
              </div>
            ))}
          </div>

          <div className="mt-10 md:mt-12 pt-8 md:pt-10 border-t border-white/10">
            <p className="text-sm md:text-base text-gray-400 mb-4 md:mb-6">
              Trusted by provider groups, specialty practices, and healthcare organizations
            </p>
            <div className="flex flex-wrap justify-center gap-6 md:gap-8 lg:gap-12 items-center opacity-60">
              {["Stryker", "Medtronic", "Boston Scientific", "Smith+Nephew", "WL Gore"]?.map((company, idx) => (
                <span key={idx} className="text-sm md:text-base text-white font-medium">
                  {company}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;